import Flex from "../../components/Flex";
import Text from "../../components/Text";
import PsychoeducationBlock from "./PsychoeducationBlock";

interface PsychoeducationSectionProps {
  data: any;
}

/**
 * "Psychoeducation Session Required" section rendered below Follow Up in the
 * visit note summaries. Always shows the Yes/No status and, when required,
 * renders the full PsychoeducationBlock details. Bundled here so each template
 * only needs a single import.
 */
const PsychoeducationSection = ({ data }: PsychoeducationSectionProps) => {
  const required = !!data?.psychoeducationSessionRequired;

  return (
    <Flex flexDirection={"column"} gap={1} mt={1} p={1}>
      <Text
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          fontWeight: 600,
        }}
      >
        Psychoeducation Session Required : {required ? "Yes" : "No"}
      </Text>
      {required && <PsychoeducationBlock data={data} />}
    </Flex>
  );
};

export default PsychoeducationSection;
